// extracted by mini-css-extract-plugin
export default {"reValidateCardSection":"S--z","paymentSection":"T--z","disabled":"U--z","sectionButtons":"V--z","usingAmazonPayMsg":"W--z"};